import React from 'react';
import { NavLink } from 'react-router-dom';
import { Logo } from '../common/ui/Logo';
import { NotificationsIcon } from '../common/ui/NotificationsIcon';
import { UserMenu } from '../users/UserMenu';

export const AdminNavbar = ({ user }) => {
    return (
        <header className="border-bottom w-100 p-3 mb-4">
            <nav className="container d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
                <NavLink
                    to="/"
                    className="navbar-brand d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none">
                    <Logo />
                    Gift Shop
                </NavLink>
                <div className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
                    <NavLink className="nav-link" to="/admin" end={true}>
                        Dashboard
                    </NavLink>
                    <NavLink className="nav-link" to="/admin/categories">
                        Categories
                    </NavLink>
                    <NavLink className="nav-link" to="/admin/products">
                        Products
                    </NavLink>
                    <NavLink className="nav-link" to="/admin/users">
                        Users
                    </NavLink>
                    <NavLink className="nav-link" to="/admin/orders">
                        Orders
                    </NavLink>
                </div>
                <NotificationsIcon />
                <UserMenu user={user} />
            </nav>
        </header>
    );
};
